var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    { staticClass: "frame-extra", attrs: { "no-body": "" } },
    [
      _c(
        "b-aspect",
        { attrs: { aspect: _vm.aspect } },
        [
          _c("b-card-img", {
            attrs: {
              src: `${_vm.product.images[0].src}.jpg`,
              alt: _vm.product.meta.short_description,
            },
          }),
        ],
        1
      ),
      _c("b-card-body", { staticClass: "p-2" }, [
        _c("p", { staticClass: "tag green" }, [
          _vm._v(_vm._s(_vm.priceString)),
        ]),
        _c("span", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.product.name)),
        ]),
      ]),
      _c(
        "b-card-footer",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "px-1", attrs: { sm: "6" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-2 mb-sm-0",
                      attrs: {
                        href: _vm.href,
                        target: "_blank",
                        variant: "info",
                        block: "",
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("info"),
                      ]),
                      _vm._v("More Info"),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "px-1", attrs: { sm: "6" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", block: "" },
                      on: { click: _vm.addToCart },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("shopping_cart"),
                      ]),
                      _vm._v("Add to Cart"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }